import NeptuneElement from '../../NeptuneElement.js';

class Container extends NeptuneElement {

    templateMarkup = `
        <section>
            <header><slot name="header"></slot></header>
            <slot name="body"></slot> 
            <footer><slot name="footer"></slot></footer>
        </section>
    `;

    componentCssUrl = '/src/components/container/container/container.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }
}

customElements.define('neptune-container', Container);
export default Container;